import styled from 'styled-components'

export const Main = styled.div`
  width: 360px;
  padding: 50px 40px;
  border-radius: 10px;
  background-color: #f1f1f1;
  margin: 10px;
  box-sizing: border-box;

  h1 {
    text-align: center;
    margin-bottom: 40px;
  }
`
